import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useLenis } from 'lenis/react'
import { forEach } from 'lodash'

export const useColorGridMotion = (collection: any[]) => {
  const motionRef = useRef<HTMLDivElement>(null)
  const lenis = useLenis()

  useGSAP(
    () => {
      if (!lenis) return

      const scrollTrigger = ScrollTrigger.batch('[data-motion-card]', {
        start: 'top bottom',
        end: 'bottom top',
        once: true,
        onEnter: (batch) =>
          gsap.fromTo(
            batch,
            { y: 30, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.8,
              ease: 'power2.out',
              stagger: {
                amount: 0.2
              }
            }
          )
      })

      return () => {
        forEach(scrollTrigger, (st) => st.kill())
      }
    },
    { scope: motionRef, dependencies: [lenis, collection] }
  )

  useGSAP(
    () => {
      const timeline = gsap.timeline({ delay: 0 })

      forEach(collection, ({ cardRef }, index) => {
        cardRef.current &&
          timeline.from(
            cardRef.current,
            {
              y: 30,
              opacity: 0,
              duration: 0.8,
              ease: 'power2.out'
            },
            index * 0.05
          )
      })

      return () => {
        timeline.kill()
      }
    },
    {
      scope: motionRef,
      revertOnUpdate: true,
      dependencies: [collection]
    }
  )

  return { motionRef }
}
